var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Circle, Line } from "react-konva";
import { useSelector } from "react-redux";
import { setEraserTrash } from "../../../../../../../redux/actions/canvas/canvas";
import getStroke from "perfect-freehand";
import { useMemo } from "react";
export var CanvasCurve = function (_a) {
    var line = _a.line;
    var _b = useSelector(function (state) { return state; }).canvas, instrument = _b.instrument, isPressed = _b.isPressed, eraserTrashCan = _b.eraserTrashCan;
    // Добавляем элемент с список для удаления
    var setTrashedItem = function (id) {
        if (!eraserTrashCan.includes(id)) {
            setEraserTrash(__spreadArray(__spreadArray([], __read(eraserTrashCan), false), [id], false));
        }
    };
    // Преобразуем массив [x1, y1, x2, y2, ...] в [[x1, y1], [x2, y2], ...]
    var pointsArray = useMemo(function () {
        var result = [];
        for (var i = 0; i < line.points.length; i += 2) {
            result.push([line.points[i], line.points[i + 1]]);
        }
        return result;
    }, [line.points]);
    // Используем perfect-freehand для создания плавной линии с переменной толщиной
    var outlinePoints = useMemo(function () {
        if (pointsArray.length < 2)
            return [];
        var stroke = getStroke(pointsArray, {
            size: line.attr.strokeWidth || 2,
            thinning: 0.6,
            smoothing: 0.5,
            streamline: 0.5,
            simulatePressure: true,
        });
        // Преобразуем обратно в плоский массив для Konva
        return stroke.flatMap(function (point) { return [point[0], point[1]]; });
    }, [pointsArray, line.attr.strokeWidth]);
    // Особая обработка для лазерной указки
    var isLaserPointer = line.isLaserPointer === true;
    var laserProps = isLaserPointer ? {
        shadowColor: '#FF0000',
        shadowBlur: 15,
        shadowOpacity: 0.8,
        fill: '#FF3333', // Более яркий красный
    } : {};
    return line.points.length > 2 ? (_jsx(Line, __assign({ opacity: eraserTrashCan.includes(line.id) ? 0.4 : 1, points: outlinePoints, onPointerOver: instrument === 'eraser' && isPressed ? function () { return setTrashedItem(line.id); } : undefined, fill: isLaserPointer ? laserProps.fill : line.attr.stroke, closed: true, globalCompositeOperation: 'source-over', hitStrokeWidth: Math.max(line.attr.strokeWidth * 2, 20) }, (isLaserPointer && {
        shadowColor: laserProps.shadowColor,
        shadowBlur: laserProps.shadowBlur,
        shadowOpacity: laserProps.shadowOpacity
    })))) : (_jsx(Circle, __assign({ opacity: eraserTrashCan.includes(line.id) ? 0.4 : 1, x: line.points[0], y: line.points[1], onPointerOver: instrument === 'eraser' && isPressed ? function () { return setTrashedItem(line.id); } : undefined, fill: isLaserPointer ? laserProps.fill : line.attr.stroke, radius: line.attr.strokeWidth * 0.7, hitStrokeWidth: Math.max(line.attr.strokeWidth * 2, 20) }, (isLaserPointer && {
        shadowColor: laserProps.shadowColor,
        shadowBlur: laserProps.shadowBlur,
        shadowOpacity: laserProps.shadowOpacity
    }))));
};
